export function removeStreetSuffixes(addressLine: string): string {
  // Some address suffixes are inconsistent between listings and subject property so
  // we need to remove them for accurate comparison
  const suffixes = [
    'ST',
    'AVE',
    'BLVD',
    'RD',
    'DR',
    'LN',
    'CT',
    'CIR',
    'PL',
    'TER',
    'WAY',
    'HWY',
    'PKWY',
    'BOULEVARD',
    'STREET',
    'AVENUE',
    'ROAD',
    'DRIVE',
    'LANE',
    'COURT',
    'CIRCLE',
    'PLACE',
    'TERRACE',
    'WAY',
    'HIGHWAY',
    'PARKWAY',
  ];

  let modifiedAddress = addressLine.toUpperCase();
  suffixes.forEach((suffix) => {
    const regex = new RegExp(`\\b${suffix}\\b`, 'g');
    modifiedAddress = modifiedAddress.replace(regex, '').trim();
  });

  return modifiedAddress;
}
